import React, { useState } from 'react';
import { Send } from 'lucide-react';
import clsx from 'clsx';

/**
 * Composer box. Enter to send, Shift+Enter for newline. Disables while the
 * hook is awaiting a response so we don't fire duplicate requests.
 */

const MAX_LEN = 2000;

export default function ChatInput({ onSend, disabled }) {
  const [value, setValue] = useState('');

  const canSend = value.trim().length > 0 && value.length <= MAX_LEN && !disabled;

  const handleSend = () => {
    if (!canSend) return;
    onSend(value.trim());
    setValue('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div
      data-drishti="chat-input"
      className="flex items-end gap-2 rounded-2xl border border-app-border/80 bg-white p-2 shadow-[0_2px_10px_rgba(15,23,42,0.04)] transition-all duration-200 focus-within:border-accent focus-within:shadow-[0_4px_16px_rgba(111,168,247,0.18)]"
    >
      <textarea
        value={value}
        onChange={(e) => setValue(e.target.value.slice(0, MAX_LEN))}
        onKeyDown={handleKeyDown}
        placeholder="Ask about CMPs, spans, fiber PM, root causes…"
        rows={1}
        aria-label="Ask Drishti a question"
        className="flex-1 resize-none bg-transparent px-2 py-2 text-sm leading-relaxed text-slate-800 placeholder:text-slate-400 focus:outline-none"
      />
      <button
        type="button"
        onClick={handleSend}
        disabled={!canSend}
        aria-label="Send question"
        className={clsx(
          'inline-flex h-9 w-9 items-center justify-center rounded-xl transition-all duration-200',
          canSend
            ? 'bg-gradient-to-br from-navy to-[#0a3768] text-white shadow-[0_4px_10px_rgba(6,43,85,0.3)] hover:-translate-y-[1px] hover:shadow-[0_6px_14px_rgba(6,43,85,0.4)] active:translate-y-0'
            : 'cursor-not-allowed bg-slate-100 text-slate-400',
        )}
      >
        <Send className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
